module.exports = __webpack_public_path__ + "assets/d6af3389fec6cf52d0c0d7e342a332e4.mp3";